export default {
	meta: {
		title: 'Projet',
		description: 'Projet'
	}
};
